(function(){
  var PROXY_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-gift-card';
  var CLIENT_PROXY_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-booking-proxy';
  var TOKENIZE_URL = 'https://pci.boulevard.app/cards/tokenize';
  var app = document.getElementById('boulevardGiftCardApp');
  if (!app) return;

  var byId = function(id){ return document.getElementById(id); };
  var form = byId('boulevardGiftForm');
  var statusNode = byId('boulevardGiftStatus');
  var amountChoices = byId('boulevardGiftAmounts');
  var customWrap = byId('boulevardGiftCustomWrap');
  var customAmount = byId('boulevardGiftCustomAmount');
  var totalNode = byId('boulevardGiftTotal');
  var offerCode = byId('boulevardGiftOfferCode');
  var applyOfferBtn = byId('boulevardGiftApplyOfferBtn');
  var offerStatus = byId('boulevardGiftOfferStatus');
  var savingsNode = byId('boulevardGiftSavings');
  var savingsAmount = byId('boulevardGiftSavingsAmount');
  var forMe = byId('boulevardGiftForMe');
  var recipientName = byId('boulevardGiftRecipientName');
  var recipientEmail = byId('boulevardGiftRecipientEmail');
  var senderName = byId('boulevardGiftSenderName');
  var deliveryDate = byId('boulevardGiftDeliveryDate');
  var messageInput = byId('boulevardGiftMessage');
  var firstName = byId('boulevardGiftFirstName');
  var lastName = byId('boulevardGiftLastName');
  var buyerEmail = byId('boulevardGiftBuyerEmail');
  var phone = byId('boulevardGiftPhone');
  var loginStart = byId('boulevardGiftLoginStart');
  var loginCode = byId('boulevardGiftLoginCode');
  var verificationCode = byId('boulevardGiftVerificationCode');
  var sendCodeBtn = byId('boulevardGiftSendCodeBtn');
  var verifyCodeBtn = byId('boulevardGiftVerifyCodeBtn');
  var loginStatus = byId('boulevardGiftLoginStatus');
  var signOutBtn = byId('boulevardGiftSignOutBtn');
  var verifiedClient = byId('boulevardGiftVerifiedClient');
  var clientName = byId('boulevardGiftClientName');
  var clientMeta = byId('boulevardGiftClientMeta');
  var savedCards = byId('boulevardGiftSavedCards');
  var newCardChoice = byId('boulevardGiftNewCardChoice');
  var useNewCard = byId('boulevardGiftUseNewCard');
  var newCardFields = byId('boulevardGiftNewCardFields');
  var cardName = byId('boulevardGiftCardName');
  var cardNumber = byId('boulevardGiftCardNumber');
  var expMonth = byId('boulevardGiftExpMonth');
  var expYear = byId('boulevardGiftExpYear');
  var cvv = byId('boulevardGiftCvv');
  var postal = byId('boulevardGiftPostal');
  var purchaseBtn = byId('boulevardGiftPurchaseBtn');
  var success = byId('boulevardGiftSuccess');
  var successCopy = byId('boulevardGiftSuccessCopy');
  var configuredLocation = String(app.getAttribute('data-location-id') || '').trim();
  if (configuredLocation === 'USE_PROXY_DEFAULT_LOCATION') configuredLocation = '';

  var state = { loading: true, submitting: false, applyingOffer: false, authBusy: false, cartId: '', itemId: 'GIFT_CARD', amount: 0, custom: false, min: 1000, max: 500000, designs: [], designId: '', offerApplied: false, offerAmount: 0, offerCode: '', discount: 0, codeId: '', authToken: '', verified: false, paymentMethods: [], paymentMethodId: '' };

  function clean(value){ return String(value == null ? '' : value).trim(); }
  function digits(value){ return clean(value).replace(/\D+/g, ''); }
  function money(cents){ return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
  function localDate(){
    var now = new Date();
    var offset = now.getTimezoneOffset() * 60000;
    return new Date(now.getTime() - offset).toISOString().slice(0, 10);
  }
  function setStatus(message, tone){
    var text = clean(message);
    statusNode.hidden = !text;
    statusNode.textContent = text;
    if (tone) statusNode.setAttribute('data-tone', tone); else statusNode.removeAttribute('data-tone');
  }
  function setLoginStatus(message, tone){
    var value = clean(message);
    loginStatus.hidden = !value;
    loginStatus.textContent = value;
    if (tone) loginStatus.setAttribute('data-tone', tone); else loginStatus.removeAttribute('data-tone');
  }
  function request(payload){
    return fetch(PROXY_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).then(function(response){
      return response.text().then(function(raw){
        var data = null;
        try { data = raw ? JSON.parse(raw) : null; } catch (_error) {}
        if (!response.ok || !data || data.ok !== true) throw new Error((data && (data.error || data.message)) || raw || 'Request failed.');
        return data;
      });
    });
  }
  function clientRequest(payload){
    return fetch(CLIENT_PROXY_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).then(function(response){
      return response.text().then(function(raw){
        var data = null;
        try { data = raw ? JSON.parse(raw) : null; } catch (_error) {}
        if (!response.ok || !data || data.ok !== true) throw new Error((data && (data.error || data.message)) || raw || 'Request failed.');
        return data;
      });
    });
  }
  function tokenize(card){
    return fetch(TOKENIZE_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ card: card }) }).then(function(response){
      return response.json().catch(function(){ return null; }).then(function(data){
        var token = data && (data.id || data.token || data.card_token || (data.data && (data.data.id || data.data.token)));
        if (!response.ok || !token) throw new Error('We could not securely verify that card. Check the details and try again.');
        return token;
      });
    });
  }
  function uniquePresetAmounts(values){
    var fallback = [5000, 10000, 15000, 20000];
    var list = Array.isArray(values) && values.length ? values : fallback;
    var seen = {};
    return list.map(Number).filter(function(value){
      var valid = Number.isFinite(value) && value >= state.min && value <= state.max && !seen[value];
      seen[value] = true;
      return valid;
    }).slice(0, 4);
  }
  function selectAmount(cents, custom){
    var priorAmount = state.amount;
    state.custom = !!custom;
    state.amount = Math.round(Number(cents) || 0);
    customWrap.hidden = !state.custom;
    Array.prototype.forEach.call(amountChoices.querySelectorAll('[data-amount]'), function(button){
      button.classList.toggle('is-selected', (!state.custom && Number(button.getAttribute('data-amount')) === state.amount) || (state.custom && button.getAttribute('data-amount') === 'custom'));
    });
    if (state.offerApplied && priorAmount !== state.amount) invalidateOffer('Amount changed. Apply the offer code again.');
    renderTotal();
  }
  function renderTotal(){
    var total = state.offerApplied ? Math.max(0, state.amount - state.discount) : state.amount;
    totalNode.textContent = total ? money(total) : (state.amount === 0 ? money(0) : '—');
    savingsNode.hidden = !state.offerApplied || state.discount <= 0;
    savingsAmount.textContent = state.discount > 0 ? '−' + money(state.discount) : '';
  }
  function setOfferStatus(message, tone){
    var value = clean(message);
    offerStatus.hidden = !value;
    offerStatus.textContent = value;
    if (tone) offerStatus.setAttribute('data-tone', tone); else offerStatus.removeAttribute('data-tone');
  }
  function invalidateOffer(message){
    state.offerApplied = false;
    state.offerAmount = 0;
    state.offerCode = '';
    state.discount = 0;
    if (message) setOfferStatus(message, 'error');
    else setOfferStatus('', '');
    renderTotal();
  }
  function renderAmounts(presets){
    var amounts = uniquePresetAmounts(presets);
    amountChoices.innerHTML = amounts.map(function(value){ return '<button class="boulevard-gift-choice" type="button" data-amount="' + value + '">' + money(value) + '</button>'; }).join('') + '<button class="boulevard-gift-choice" type="button" data-amount="custom">Custom</button>';
    if (amounts.length) selectAmount(amounts[0], false);
  }
  function purchaserFullName(){ return [clean(firstName.value), clean(lastName.value)].filter(Boolean).join(' '); }
  function syncForMe(){
    recipientName.disabled = forMe.checked;
    recipientEmail.disabled = forMe.checked;
    if (forMe.checked) {
      recipientName.value = purchaserFullName();
      recipientEmail.value = clean(buyerEmail.value);
    }
  }
  function renderPaymentMethods(){
    savedCards.innerHTML = '';
    state.paymentMethods.forEach(function(method){
      var label = document.createElement('label');
      label.className = 'boulevard-gift-saved-card';
      var input = document.createElement('input');
      input.type = 'radio'; input.name = 'boulevardGiftPayment'; input.value = clean(method.id);
      input.checked = state.paymentMethodId === clean(method.id);
      var copy = document.createElement('span');
      var brand = clean(method.brand || method.name).replace(/_/g, ' ');
      copy.textContent = brand + ' •••• ' + clean(method.last4) + (method.exp_month && method.exp_year ? '  Exp. ' + method.exp_month + '/' + method.exp_year : '');
      label.appendChild(input); label.appendChild(copy); savedCards.appendChild(label);
    });
    savedCards.hidden = !state.paymentMethods.length;
    newCardChoice.hidden = !state.paymentMethods.length;
    useNewCard.checked = !state.paymentMethodId;
    newCardFields.hidden = !!state.paymentMethodId;
  }
  function setVerified(data){
    var client = data.client || {};
    var clientFirstName = clean(client.first_name || client.firstName);
    var clientLastName = clean(client.last_name || client.lastName);
    var clientEmail = clean(client.email);
    var clientPhone = clean(client.phone || client.mobilePhone);
    state.verified = true;
    state.codeId = '';
    state.authToken = clean(data.auth_token);
    state.paymentMethods = Array.isArray(data.payment_methods) ? data.payment_methods : [];
    var defaultMethod = state.paymentMethods.filter(function(method){ return method.is_default; })[0] || state.paymentMethods[0];
    state.paymentMethodId = defaultMethod ? clean(defaultMethod.id) : '';
    if (clientFirstName) firstName.value = clientFirstName;
    if (clientLastName) lastName.value = clientLastName;
    if (clientEmail) buyerEmail.value = clientEmail;
    if (clientPhone) phone.value = clientPhone;
    if (state.offerApplied) invalidateOffer('Profile verified. Apply the offer code again.');
    [firstName, lastName, buyerEmail, phone].forEach(function(input){ input.disabled = !!clean(input.value); });
    syncForMe();
    loginStart.hidden = true; loginCode.hidden = true; signOutBtn.hidden = false;
    verifiedClient.hidden = false;
    clientName.textContent = clean(client.name) || [clientFirstName, clientLastName].filter(Boolean).join(' ') || 'Verified client';
    clientMeta.textContent = [clientPhone, clientEmail].filter(Boolean).join(' • ');
    setLoginStatus(state.paymentMethods.length ? 'Profile verified. Choose a saved card below.' : 'Profile verified. No saved cards were found, so please enter a new card.', 'success');
    renderPaymentMethods();
  }
  function resetAuthentication(){
    state.codeId = ''; state.authToken = ''; state.verified = false; state.paymentMethods = []; state.paymentMethodId = '';
    verificationCode.value = '';
    [firstName, lastName, buyerEmail, phone].forEach(function(input){ input.disabled = false; });
    loginStart.hidden = false; loginCode.hidden = true; signOutBtn.hidden = true;
    verifiedClient.hidden = true; clientName.textContent = 'Client Name'; clientMeta.textContent = '';
    setLoginStatus('', ''); renderPaymentMethods();
  }
  function validate(){
    var selectedAmount = state.custom ? Math.round(Number(customAmount.value) * 100) : state.amount;
    if (!Number.isFinite(selectedAmount) || selectedAmount < state.min || selectedAmount > state.max) throw new Error('Choose an amount between ' + money(state.min) + ' and ' + money(state.max) + '.');
    state.amount = selectedAmount;
    syncForMe();
    var required = [recipientName, recipientEmail, senderName, deliveryDate, firstName, lastName, buyerEmail, phone];
    if (!state.paymentMethodId) required = required.concat([cardName, cardNumber, expMonth, expYear, cvv, postal]);
    for (var i = 0; i < required.length; i += 1) if (!clean(required[i].value)) throw new Error('Complete every required field before purchasing.');
    if (!/^\S+@\S+\.\S+$/.test(clean(recipientEmail.value)) || !/^\S+@\S+\.\S+$/.test(clean(buyerEmail.value))) throw new Error('Enter valid purchaser and recipient email addresses.');
    if (deliveryDate.value < localDate()) throw new Error('Delivery date cannot be in the past.');
    var number = digits(cardNumber.value);
    var month = Number(digits(expMonth.value));
    var year = digits(expYear.value);
    if (!state.paymentMethodId && (number.length < 13 || month < 1 || month > 12 || year.length !== 4 || digits(cvv.value).length < 3)) throw new Error('Check the card number, expiration date, and CVV.');
    return { amount: selectedAmount, number: number, month: month, year: Number(year), cvv: digits(cvv.value) };
  }
  function setBusy(busy){ state.submitting = busy; var locked = busy || state.loading || state.applyingOffer || state.authBusy; purchaseBtn.disabled = locked; applyOfferBtn.disabled = locked; sendCodeBtn.disabled = locked; verifyCodeBtn.disabled = locked; purchaseBtn.textContent = busy ? 'Completing purchase…' : 'Purchase gift card'; applyOfferBtn.textContent = state.applyingOffer ? 'Applying…' : (state.offerApplied ? 'Applied' : 'Apply'); sendCodeBtn.textContent = state.authBusy && !state.codeId ? 'Sending…' : 'Text me a code'; verifyCodeBtn.textContent = state.authBusy && state.codeId ? 'Verifying…' : 'Verify'; }
  function currentAmount(){ return state.custom ? Math.round(Number(customAmount.value) * 100) : state.amount; }
  function applyOffer(){
    var code = clean(offerCode.value).toUpperCase();
    var amount = currentAmount();
    var buyer = { first_name: clean(firstName.value), last_name: clean(lastName.value), email: clean(buyerEmail.value), phone: clean(phone.value) };
    if (!code) throw new Error('Enter an offer code first.');
    if (!Number.isFinite(amount) || amount < state.min || amount > state.max) throw new Error('Choose a valid gift card amount first.');
    if (!buyer.first_name || !buyer.last_name || !buyer.email || !buyer.phone) throw new Error('Enter your details before applying an offer code.');
    if (!/^\S+@\S+\.\S+$/.test(buyer.email)) throw new Error('Enter a valid purchaser email address.');
    state.applyingOffer = true; state.offerApplied = false; setBusy(false); setOfferStatus('Checking this code with Boulevard…', 'loading');
    return request({ action: 'gift-card-apply-offer', location_id: configuredLocation, cart_id: state.cartId, auth_token: state.authToken, item_id: state.itemId, design_id: state.designId, amount: amount, offer_code: code, first_name: buyer.first_name, last_name: buyer.last_name, email: buyer.email, phone: buyer.phone }).then(function(data){
      state.cartId = clean(data.cart_id);
      state.offerApplied = true;
      state.offerAmount = amount;
      state.offerCode = clean(data.offer && data.offer.code) || code;
      state.discount = Number(data.summary && data.summary.discountAmount) || 0;
      offerCode.value = state.offerCode;
      setOfferStatus((clean(data.offer && data.offer.name) || 'Offer') + ' applied.', 'success');
      renderTotal();
    }).finally(function(){ state.applyingOffer = false; setBusy(false); });
  }
  function loadOptions(){
    setStatus('Loading live Boulevard gift card options…', 'loading');
    return request({ action: 'gift-card-options', location_id: configuredLocation }).then(function(data){
      state.cartId = clean(data.cart_id);
      state.itemId = clean(data.item_id) || 'GIFT_CARD';
      state.min = Number(data.min_amount) || 1000;
      state.max = Number(data.max_amount) || 500000;
      state.designs = Array.isArray(data.designs) ? data.designs : [];
      state.designId = state.designs.length ? clean(state.designs[0].id) : '';
      customAmount.min = String(state.min / 100);
      customAmount.max = String(state.max / 100);
      renderAmounts(data.price_presets);
      setStatus('', '');
    }).catch(function(error){
      setStatus(error.message || String(error), 'error');
    }).finally(function(){ state.loading = false; setBusy(false); });
  }

  amountChoices.addEventListener('click', function(event){
    var button = event.target.closest('[data-amount]');
    if (!button) return;
    var value = button.getAttribute('data-amount');
    if (value === 'custom') { selectAmount(Math.round(Number(customAmount.value) * 100), true); customAmount.focus(); }
    else selectAmount(Number(value), false);
  });
  customAmount.addEventListener('input', function(){ selectAmount(Math.round(Number(customAmount.value) * 100), true); });
  offerCode.addEventListener('input', function(){
    offerCode.value = offerCode.value.toUpperCase();
    if (state.offerApplied && clean(offerCode.value) !== state.offerCode) invalidateOffer('Code changed. Apply it again.');
  });
  applyOfferBtn.addEventListener('click', function(){
    try { applyOffer().catch(function(error){ invalidateOffer(); setOfferStatus(error.message || String(error), 'error'); }); }
    catch (error) { setOfferStatus(error.message || String(error), 'error'); }
  });
  sendCodeBtn.addEventListener('click', function(){
    var mobilePhone = digits(phone.value);
    if (mobilePhone.length !== 10) { setLoginStatus('Enter the 10-digit mobile number on your Boulevard profile first.', 'error'); phone.focus(); return; }
    state.authBusy = true; state.codeId = ''; setBusy(false); setLoginStatus('Requesting a verification code…', 'loading');
    clientRequest({ action: 'client-auth-start', method: 'phone', identifier: phone.value }).then(function(data){
      state.codeId = clean(data.request_id);
      loginStart.hidden = true; loginCode.hidden = false;
      setLoginStatus(data.note || 'Boulevard texted a verification code to ' + phone.value + '.', 'success');
      verificationCode.focus();
    }).catch(function(error){ setLoginStatus(error.message || String(error), 'error'); }).finally(function(){ state.authBusy = false; setBusy(false); });
  });
  verifyCodeBtn.addEventListener('click', function(){
    var code = digits(verificationCode.value);
    if (!state.codeId || !code) { setLoginStatus('Enter the code from the Boulevard text message.', 'error'); return; }
    state.authBusy = true; setBusy(false); setLoginStatus('Verifying your profile…', 'loading');
    clientRequest({ action: 'client-auth-verify', method: 'phone', identifier: phone.value, request_id: state.codeId, code: code }).then(function(session){
      if (!clean(session.client_token)) throw new Error('Boulevard did not return a verified client session.');
      return request({ action: 'gift-card-authenticate-client', cart_id: state.cartId, client_token: session.client_token, location_id: configuredLocation }).then(function(data){
        if ((!data.client || !clean(data.client.id)) && session.client) data.client = session.client;
        state.cartId = clean(data.cart_id) || state.cartId;
        setVerified(data);
      });
    }).catch(function(error){ setLoginStatus(error.message || String(error), 'error'); }).finally(function(){ state.authBusy = false; setBusy(false); });
  });
  verificationCode.addEventListener('input', function(){ verificationCode.value = digits(verificationCode.value).slice(0, 8); });
  signOutBtn.addEventListener('click', function(){
    resetAuthentication(); invalidateOffer(); state.loading = true; setBusy(false); loadOptions();
  });
  savedCards.addEventListener('change', function(event){
    if (event.target && event.target.name === 'boulevardGiftPayment') { state.paymentMethodId = clean(event.target.value); renderPaymentMethods(); }
  });
  useNewCard.addEventListener('change', function(){ if (useNewCard.checked) { state.paymentMethodId = ''; renderPaymentMethods(); } });
  forMe.addEventListener('change', syncForMe);
  firstName.addEventListener('input', function(){ syncForMe(); if (state.offerApplied) invalidateOffer('Purchaser details changed. Apply the code again.'); });
  lastName.addEventListener('input', function(){ syncForMe(); if (state.offerApplied) invalidateOffer('Purchaser details changed. Apply the code again.'); });
  buyerEmail.addEventListener('input', function(){ syncForMe(); if (state.offerApplied) invalidateOffer('Purchaser details changed. Apply the code again.'); });
  phone.addEventListener('input', function(){
    var value = digits(phone.value); if (value.length === 11 && value.charAt(0) === '1') value = value.slice(1);
    phone.value = value.length <= 3 ? value : value.length <= 6 ? '(' + value.slice(0,3) + ') ' + value.slice(3) : '(' + value.slice(0,3) + ') ' + value.slice(3,6) + '-' + value.slice(6,10);
    if (state.offerApplied) invalidateOffer('Purchaser details changed. Apply the code again.');
  });
  cardNumber.addEventListener('input', function(){ cardNumber.value = digits(cardNumber.value).slice(0,19).replace(/(.{4})/g, '$1 ').trim(); });
  expMonth.addEventListener('input', function(){ expMonth.value = digits(expMonth.value).slice(0,2); });
  expYear.addEventListener('input', function(){ expYear.value = digits(expYear.value).slice(0,4); });
  cvv.addEventListener('input', function(){ cvv.value = digits(cvv.value).slice(0,4); });
  deliveryDate.min = localDate();
  deliveryDate.value = localDate();

  form.addEventListener('submit', function(event){
    event.preventDefault();
    if (state.submitting || state.loading) return;
    try {
      if (!state.cartId) throw new Error('Gift card checkout is not ready. Refresh the page and try again.');
      var values = validate();
      if (clean(offerCode.value) && (!state.offerApplied || state.offerAmount !== values.amount)) throw new Error('Apply the offer code to this amount before purchasing.');
      setBusy(true); setStatus('Securely processing your gift card purchase…', 'loading');
      var payment = state.paymentMethodId ? Promise.resolve('') : tokenize({ name: clean(cardName.value), number: values.number, cvv: values.cvv, exp_month: values.month, exp_year: values.year, address_postal_code: clean(postal.value) });
      payment.then(function(token){
        return request({ action: 'gift-card-purchase', location_id: configuredLocation, cart_id: state.cartId, auth_token: state.authToken, item_id: state.itemId, design_id: state.designId, amount: values.amount, offer_code: state.offerApplied ? state.offerCode : '', recipient_name: clean(recipientName.value), recipient_email: clean(recipientEmail.value), sender_name: clean(senderName.value), delivery_date: deliveryDate.value, message: clean(messageInput.value), first_name: clean(firstName.value), last_name: clean(lastName.value), email: clean(buyerEmail.value), phone: clean(phone.value), payment_method_id: state.paymentMethodId, card_token: token });
      }).then(function(data){
        form.hidden = true; success.hidden = false; setStatus('', '');
        var when = data.delivery_date === localDate() ? 'today' : 'on ' + new Date(data.delivery_date + 'T12:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
        successCopy.textContent = money(data.amount || values.amount) + ' will be emailed to ' + clean(data.recipient_name || recipientName.value) + ' ' + when + '.';
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).catch(function(error){ setStatus(error.message || String(error), 'error'); }).finally(function(){ setBusy(false); });
    } catch (error) { setStatus(error.message || String(error), 'error'); }
  });

  setBusy(false);
  loadOptions();
})();
